import React from "react";

import { routes as regularUserRoutes } from "apps/RegularUser/constants";
import { view } from "modules/Communities";

const CommunitiesPage = () => <view.Communities marketingUrl={regularUserRoutes.community.getPath()} />;

export default CommunitiesPage;
